import React from 'react';
import { Link } from 'react-router-dom';
import { PAGE_URLS } from '@constants';

export const BackToLoginLink = () => (
    <Link to={PAGE_URLS.CLIENT_LOGIN}>Back to login</Link>
);

export default BackToLoginLink;
